import { createAsyncThunk } from "@reduxjs/toolkit";
import { getMinimalEvents } from "apis/EventServiceApi";
import { ThunkAPI } from "store/types";
import {
  FetchEventListParams,
  SearchDocumentsPayload,
} from "./EventList.types";
import { setEventList } from "./eventList.slice";

export const fetchEventList = createAsyncThunk<
  void,
  FetchEventListParams,
  ThunkAPI
>("eventList/fetchEventList", async (params, thunkAPI) => {
  try {
    const payload: SearchDocumentsPayload = {
      orderBy: "created_at",
      arrangeOrder: "asc",
      searchText: params.searchText,
      typeEvents: params.typeEvents,
      dataPage: params.page,
      limit: params.limit,
      ...(params.publicUserId && { publicUserId: params.publicUserId }),
    };
    const response = await getMinimalEvents(payload);
    thunkAPI.dispatch(setEventList(response));
  } catch (error) {
    if (
      error instanceof Error &&
      error.message === "You have no events planned"
    ) {
      return thunkAPI.rejectWithValue(error.message);
    }
    return thunkAPI.rejectWithValue("An unexpected error occurred");
  }
});
